/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["agm-map[_ngcontent-%COMP%]{height:300px!important}"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/app.component.css.shim.ngstyle.js.pre-build-optimizer.js